module.exports = __webpack_public_path__ + "static/media/meropathsala.fe1aca12.png";